'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilitySetsViewCtrl', function ($scope, user, positions, me, toastr,
                                       pending_in_review_availability_sets, userAvailabilityChangeRequests,
                                       Session, ServerUrls, $uibModal, org, SAErrorHandler,
                                       AvailabilitySets, TimeService, $state, availabilitySet, UserPermissionsService) {

    $scope.user = user;
    $scope.me = me;
    $scope.org = org;
    $scope.pending_in_review_availability_sets = pending_in_review_availability_sets;
    $scope.userAvailabilityChangeRequests = userAvailabilityChangeRequests;
    $scope.currentSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isInEffect() && availSet.$isApproved();
    });

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null,
      placeholderText: ''
    };

    function processRawPermissions() {
      var mySet = $scope.me.id === $scope.user.id;
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canSendMessage: mySet && rawPerms['availability_sets.add_message_to_mine'] || rawPerms['availability_sets.add_message'],
        canApprove: rawPerms['availability_sets.approve'],
        canDisapprove: rawPerms['availability_sets.disapprove'],
        canViewChangeRequest: mySet && rawPerms['user_availability_change_requests.view_mine'] || rawPerms['availability_change_requests.view'],
        canViewAvailabilityManagement: rawPerms['ui.availability.view_management'],
        canViewDesiredHours: mySet || rawPerms['availability_sets.view_target'],
        canViewTargetHours: rawPerms['availability_sets.view_target'],
        canChangeTargetHours: rawPerms['availability_sets.change_target_hours'],
        canViewReasons: mySet || rawPerms['availability_sets.view_reasons']
      };
    }

    var permissionsToLookup = [
      'availability_sets.add_message_to_mine',
      'availability_sets.add_message',
      'availability_sets.approve',
      'availability_sets.disapprove',
      'ui.availability.view_management',
      'user_availability_change_requests.view_mine',
      'availability_change_requests.view',
      'availability_sets.view_target',
      'availability_sets.change_target_hours',
      'availability_sets.view_reasons'
    ];

    UserPermissionsService.getCanDict(permissionsToLookup, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();

        setMessagePlaceholderText();
    });

    $scope.availabilitySet = availabilitySet;

    $scope.startOfWeekDay = Session.getStartOfWeekDay();

    $scope.datepickers = {
      expiresInDateOpened: false
    };

    $scope.targetHours = {
      fromServer: $scope.availabilitySet.target_hours,
      editable: _.cloneDeep($scope.availabilitySet.target_hours)
    };

    $scope.openExpiresInDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.expiresInDateOpened === true) {
        $scope.datepickers.expiresInDateOpened = false;
      } else {
        $scope.datepickers.expiresInDateOpened = true;
      }
    };

    $scope.minDate = new Date(moment().hours(0).minutes(0).seconds(0).milliseconds(0).add(moment().tz(Session.getTimezone())._offset, 'minutes').format('YYYY-MM-DD hh:mm'));

    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      showWeeks: false
    };

    $scope.formData = {
      desiredEffectiveDate: $scope.availabilitySet.desired_effective_date.toDate(),
      desired_hours: $scope.availabilitySet.desired_hours,
      target_hours: $scope.availabilitySet.target_hours,
      message: ''
    };




    $scope.updateTargetHours = function() {
      $scope.availabilitySet.$update({
        target_hours: $scope.targetHours.editable,
        state: $scope.availabilitySet.state
      })
        .then(function(response) {
          $scope.availabilitySet.target_hours = response.target_hours;
          $scope.targetHours.fromServer = $scope.availabilitySet.target_hours;
        }, function() {
          toastr.error('We were unable to update target hours due to an error.', 'Error');
        });
    };


    $scope.sendMessage = function() {
      $scope.availabilitySet.$update({
        message: $scope.formData.message,
        state: $scope.availabilitySet.state
      })
          .then(function(response) {
            $scope.availabilitySet = response;
          $scope.formData.message = '';
          }, function() {
            toastr.error('We were unable to add a message to this availability set due to an error.', 'Error');
          });
    };

    $scope.submitForReview = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.IN_REVIEW
      };

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function() {

          });
    };


    $scope.approveSet = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.APPROVED
      };


      if ($scope.targetHours.fromServer !== $scope.targetHours.editable) {
        updateData['target_hours'] = $scope.targetHours.editable;
      }

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function() {
            toastr.error('We were unable to approve this availability set due to an error.', 'Error');
          });
    };

    $scope.disapproveSet = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.DISAPPROVED
      };

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function() {
            toastr.error('We were unable to disapprove this availability set due to an error.', 'Error');
          });
    };

    function setMessagePlaceholderText() {
      if ($scope.me.id === $scope.availabilitySet.user_id && $scope.state.derivedPermissions.canSendMessage) {
        $scope.state.placeholderText = 'Reply to your availability update request.';
      } else if ($scope.state.derivedPermissions.canSendMessage  && $scope.me.id !== $scope.availabilitySet.user_id) {
        $scope.state.placeholderText = 'Ask a question or provide explanation for your decision.';
      }
    }


  });
